import type { StaticEntityType } from "@config";
import { useViewContext } from "@editor-providers";
import { Combos } from "@library-containers/combos";
import { parseListDynamicVariable } from "@/shared";
import { ComboView } from "./Combo.view";

export const ComboLibrary = ({ entity }: { entity: StaticEntityType }) => {
  const { settings } = entity;
  const ComboOption = Combos[settings?.name];
  const { view } = useViewContext();

  const updatedEntity =
    settings.listDynamicVariable && view === "default"
      ? {
          ...entity,
          children: parseListDynamicVariable(
            entity.children,
            settings.listDynamicVariable,
          ),
        }
      : entity;

  return (
    <ComboView entity={updatedEntity}>
      <ComboOption entity={updatedEntity} />
    </ComboView>
  );
};
